<template>
  <div class="irp-activity-tab" data-testid="irp-activity-tab">Activity</div>
</template>
